/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { unsetUserData } from '../../user/actions';
import { VideoPlayerConfig } from './types';

const initialState: VideoPlayerConfig = {
  volume: 1,
  muted: true,
};

const videoPlayerConfigSlice = createSlice({
  name: 'videoPlayerConfig',
  initialState,
  reducers: {
    setVolume: (state, { payload }: PayloadAction<number | string>) => {
      const volume = Number(payload);
      if (volume >= 0 && volume <= 1) {
        state.volume = volume;
        state.muted = volume === 0;
      }
    },
    setMuted: (state, { payload }: PayloadAction<boolean>) => {
      state.muted = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(unsetUserData, () => initialState);
  },
});

export default videoPlayerConfigSlice;
